import { ReactNode } from 'react';

import ChevronRightIcon from '@flipster/react/icon/generated/ChevronRightIcon';
import NewColorIcon from '@flipster/react/icon/generated/NewColorIcon';
import { css } from '@flipster/styled-system/css';
import { flex } from '@flipster/styled-system/patterns';
import { token } from '@flipster/styled-system/tokens';
import { map } from '@flipster/utils/map';

interface Props {
  icon?: ReactNode;
  title: ReactNode;
  description?: ReactNode;
  action?: ReactNode;
  showNewIcon?: boolean;
}

const TradeSettingItem = ({ showNewIcon = false, icon, title, description, action }: Props) => {
  return (
    <div>
      <div
        className={flex({
          align: 'center',
          justify: 'space-between',
          textStyle: 'Text/L/Regular',
          color: 'content.default.level-5',
        })}
      >
        <div className={flex({ align: 'center', gap: 8 })}>
          {icon}
          <span>{title}</span>
          {showNewIcon && <NewColorIcon size={16} />}
        </div>
        {action ?? <ChevronRightIcon size={16} color={token('colors.content.default.level-3')} />}
      </div>
      {/* oxlint-disable-next-line @typescript-eslint/no-shadow */}
      {map(description, (description) => (
        <p
          className={css({
            textStyle: 'Text/M/Regular',
            color: 'content.default.level-2',
            pt: 8,
            textAlign: 'left',
            whiteSpace: 'pre-line',
          })}
        >
          {description}
        </p>
      ))}
    </div>
  );
};

export default TradeSettingItem;
